import { useQuery } from '@tanstack/react-query';
import { fetcher } from 'src/api/fetcher';
import { API_RESOURCES } from 'src/utils/constants';

export const useDocumentParserInstruction = parserTemplateUri => {
  return useQuery({
    queryKey: ['documentParserInstructionByTemplateUri', parserTemplateUri],
    queryFn: () =>
      fetcher(API_RESOURCES.DOCUMENT_PARSER_INSTRUCTION, {
        params: {
          'filter[parser_template]': parserTemplateUri,
          sort: 'position',
        },
      }),
    enabled: !!parserTemplateUri,
    select: data => data.resources,
    refetchOnWindowFocus: false,
  });
};

export const useDocumentParserInstructionReports = (documentUri, workInstructionReportUri) => {
  return useQuery({
    queryKey: ['documentParserInstructionReports', documentUri, workInstructionReportUri],
    queryFn: () =>
      fetcher(API_RESOURCES.DOCUMENT_PARSER_INSTRUCTION_REPORT, {
        params: {
          'filter[document]': documentUri,
          'filter[work_instruction_report]': workInstructionReportUri,
        },
      }),
    enabled: !!workInstructionReportUri && !!documentUri,
    select: data => data.resources,
    refetchOnWindowFocus: false,
  });
};

export const useAutoDocumentParsingJobs = (
  documentUri,
  refetchInterval = false,
  enabled = true
) => {
  return useQuery({
    queryKey: ['autoDocumentParsingJobs', documentUri],
    queryFn: () =>
      fetcher(API_RESOURCES.AUTO_DOCUMENT_PARSING_JOB, {
        params: {
          'filter[document]': documentUri,
        },
      }),
    enabled: enabled && !!documentUri,
    select: data => data.resources,
    refetchOnWindowFocus: false,
    refetchInterval: refetchInterval,
  });
};
